import React, { useEffect, useState } from 'react';
import Shell from '../../components/Shell';
import api from '../../services/api';
import { interestOptionLabel } from '../../constants/interestOptions';

type Row = {
  _id: string;
  userName?: string;
  userEmail?: string;
  fundSlugs: string[];
  amountHint?: string;
  notes?: string;
  createdAt?: string;
};

export default function AdminInterestPage() {
  const [rows, setRows] = useState<Row[]>([]);

  useEffect(() => {
    api.get('/admin/interest').then((r) => setRows(r.data));
  }, []);

  return (
    <Shell title="Admin · Interest inbox">
      <h1 className="font-display text-3xl">Soft interest</h1>
      <ul className="mt-8 divide-y divide-mist-200 border-y border-mist-200">
        {rows.length === 0 && (
          <li className="py-6 text-sm text-ink-700">No submissions yet.</li>
        )}
        {rows.map((r) => (
          <li key={r._id} className="py-5">
            <p className="font-medium">
              {r.userName}{' '}
              <span className="text-sm font-normal text-ink-700">
                &lt;{r.userEmail}&gt;
              </span>
            </p>
            <p className="mt-1 text-sm text-ink-700">
              Funds:{' '}
              {r.fundSlugs.map((s) => interestOptionLabel(s)).join(', ')}
            </p>
            {r.amountHint && (
              <p className="text-sm text-ink-700">Amount: {r.amountHint}</p>
            )}
            {r.notes && <p className="mt-2 text-sm">{r.notes}</p>}
            {r.createdAt && (
              <p className="mt-2 text-xs text-ink-700/70">
                {new Date(r.createdAt).toLocaleString()}
              </p>
            )}
          </li>
        ))}
      </ul>
    </Shell>
  );
}
